import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import LiveLessonsTable from './LiveLessonsTable';
const LiveLessons = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Live Lessons' parent='Live Lessons'  />
      <Container fluid={true}>
        <Row>
          <LiveLessonsTable  />
        </Row>
      </Container>
    </Fragment>
  );
};

export default LiveLessons;
